import { Message } from "../chatbot";

export async function sendMessage(
  url: string,
  message: Message,
  halfYear?: string
): Promise<Message> {
  if (!url || !message) {
    return {
      role: "assistant",
      content: "Error: No message provided or the URL was wrong.",
    };
  }
  const params = [];

  if (halfYear) {
    params.push(`halfYear=${halfYear}`);
  }

  try {
    const response = await fetch(`${url}?${params.join("&")}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        data: {
          message: message.content,
          metadata: message.metadata,
        },
      }),
    });

    if (response.status >= 400) {
      throw new Error(`Send failed with status ${response.status}.`);
    }

    const json = (await response.json()) as {
      data: {
        role: "assistant";
        content: string;
        buttons?: Array<{
          id: string;
          label: string;
          value: string;
        }>;
      };
    };

    const responseMessage: Message = {
      role: json.data.role,
      content: json.data.content,
    };

    if (json.data.buttons && json.data.buttons.length > 0) {
      responseMessage.buttons = json.data.buttons;
    }

    return responseMessage;
  } catch {
    return {
      role: "assistant",
      content: "Something went wrong with the request.",
    };
  }
}
